import ExchangeIcon from './Exchange'
import AddTagIcon from './AddTag'

const FormAction = {
    ExchangeIcon,
    AddTagIcon
}
export default FormAction
